import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
  imports: [CommonModule, MatProgressBarModule, MatDialogModule],
})
export class LoadingDialogComponent implements OnInit, OnChanges {
  dialogRef = inject<MatDialogRef<LoadingDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  @Input() isDialog = true;
  @Input() headline = 'Loading';
  @Input() content: string;
  @Input() changeContent: string[];
  @Input() maxTime = 28000;
  @Input() showNetworkLoading = true;
  confirm: string;
  @Input() loadingVal = 0;
  currContentIdx: number;
  timeoutList = [];

  constructor() {
    const data = this.data;

    if (!this.headline && this.isDialog) {
      this.headline = data.headline;
    }
    if (!this.content && this.isDialog) {
      this.content = data.content;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && Object.keys(changes).includes('showNetworkLoading')) {
      if (!this.showNetworkLoading) {
        this.endModal(true);
      }
    }
  }

  ngOnInit() {
    if (this.changeContent && this.changeContent.length > 0) {
      if (!this.isDialog) {
        this.content = this.changeContent[0];
        this.currContentIdx = 0;
      }
    }
    if (!this.loadingVal) {
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 10;
        }, this.maxTime * 0.1)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 17;
          this.advanceContent();
        }, this.maxTime * 0.17)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 25;
        }, this.maxTime * 0.25)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 37;
        }, this.maxTime * 0.37)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 45;
          this.advanceContent();
        }, this.maxTime * 0.45)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 60;
        }, this.maxTime * 0.6)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 63;
        }, this.maxTime * 0.63)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 65;
        }, this.maxTime * 0.65)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 68;
          this.advanceContent();
        }, this.maxTime * 0.68)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 70;
        }, this.maxTime * 0.7)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 78;
        }, this.maxTime * 0.78)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 83;
        }, this.maxTime * 0.83)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 86;
        }, this.maxTime * 0.86)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 90;
        }, this.maxTime * 0.9)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 93;
        }, this.maxTime * 0.93)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 95;
        }, this.maxTime * 0.95)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 95;
        }, this.maxTime * 0.95)
      );
      this.timeoutList.push(
        setTimeout(() => {
          this.loadingVal = 98;
          this.advanceContent();
        }, this.maxTime * 0.98)
      );
    }
  }

  private advanceContent() {
    if (this.isDialog || !this.changeContent?.length) {
      return;
    }
    const lastIdx = this.changeContent.length - 1;
    this.currContentIdx = Math.min((this.currContentIdx ?? -1) + 1, lastIdx);
    this.content = this.changeContent[this.currContentIdx];
  }

  progressColor() {
    if (this.loadingVal === 100) {
      return 'accent';
    }
    return 'primary';
  }

  endModal(success = true) {
    this.timeoutList.forEach(timeoutItem => {
      clearTimeout(timeoutItem);
    });
    this.timeoutList = [];

    if (success) {
      this.loadingVal = 100;

      if (!this.isDialog) {
        this.content =
          'Your file has been parsed! Thank you for your patience.';
      }

      if (this.isDialog) {
        setTimeout(() => {
          this.dialogRef.close();
        }, 1000);
      }
    } else {
      this.loadingVal = -1;
      if (this.isDialog) {
        this.dialogRef.close();
      }
    }
  }
}
